export const SEARCH_FORM_SUBMIT = 'COORDINATOR.ONLINE_SURVEYS.SEARCH_FORM_SUBMIT';
export const SORT_CHANGE = 'COORDINATOR.ONLINE_SURVEYS.SORT_CHANGE';
export const PAGE_CHANGE = 'COORDINATOR.ONLINE_SURVEYS.PAGE_CHANGE';
export const FETCH_LIST = 'COORDINATOR.ONLINE_SURVEYS.FETCH_LIST';
export const FETCH_ONE = 'COORDINATOR.ONLINE_SURVEY.FETCH_ONE';
export const CLEAR_ONE = 'COORDINATOR.ONLINE_SURVEY.CLEAR_ONE';
